import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService } from 'src/app/services/sharedservice.service';
import { ToastrManager } from 'ng6-toastr-notifications';
declare var $:any;
@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
  verify: FormGroup;
  u_email:any = JSON.parse(localStorage.getItem("user_emailAgency"));
  user_email:any;
  sc_type:any;
  register:any;

  matcherror:boolean=false;
  submitted = false;
  constructor(private activatedRoute: ActivatedRoute, private fb: FormBuilder, public httpClient: SharedserviceService, public router: Router,private toastr: ToastrManager) {
   //this.user.jwt="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo1LCJ1c2VyX2VtYWlsIjoidGVzdDJAZ21haWwuY29tIiwidHlwZSI6ImN1c3RvbWVycyJ9.krOysYurlj4bu4swegrU92AzmuIAmE0cRhvAyJ-YqNw";
   var userdata:any = JSON.parse(localStorage.getItem("user_emailAgency"));
   if(userdata !=null){ 
     this.user_email = this.u_email.email;
     this.sc_type = localStorage.getItem("type")
    }
  }
 
  ngOnInit() {
    this.verify = this.fb.group({
      otp:['', Validators.required],
      password:['', Validators.required],
      confirm_password:['', Validators.required],
      email:[''],
    });
  }

  get f() { return this.verify.controls; }
  verify_user(){
    
    this.submitted = true;
    // stop here if form is invalid
    if (this.verify.invalid) { 
      return;
    }

    const self=this;
    self.httpClient.loadingShow = true;
    self.verify.patchValue({email:this.user_email});
    
     
    this.httpClient.patch('v1/users/reset_password',this.verify.value).subscribe((res)=> {
    self.httpClient.loadingShow = false;
      if(res.replyCode == 'success') { 
        this.toastr.successToastr(res.replyMsg, 'Success');
         if(this.sc_type == 'register'){
          $('#success').show(1000);
          setTimeout(function(){
            $('#success').hide(1000);
            self.router.navigate(['/auth/login']);
          }, 2000);
         }else{
          self.router.navigate(['/auth/login']);
         }
      }else{
       
        $('#error').show(1000);
        setTimeout(function(){
          $('#error').hide(1000);
        }, 4000);
      }
    },err=>{
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }

  match(val)
  { 
    var pass=this.verify.value
    if(val != pass.password){
        this.matcherror=true;
    }else{
        this.matcherror=false;
    }
  }

  resendOTP(){
    
    var email = {
      'email' : this.user_email,
    }
    const self=this;
    this.httpClient.loadingShow = true;
    this.httpClient.patch('resend', email).subscribe((res)=> {
      self.httpClient.loadingShow = false;
      if(res.success) {
        alert('OTP Send Successfully');
      }else{
        $('#error').show(1000);
        setTimeout(function(){
          $('#error').hide(1000);
        }, 4000);
      }

    });
     
  }


}
